export default __webpack_public_path__ + "static/media/progressbar_2.e0384dc5.PNG";